export default function PlusIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>

    // <svg className={className} width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <mask id="mask0_1_2436" maskUnits="userSpaceOnUse" x="0" y="0" width="37" height="36">
    //     <rect x="0.5" width="36" height="36" fill="#D9D9D9" />
    //   </mask>
    //   <g mask="url(#mask0_1_2436)">
    //     <path d="M17 19.5H8V16.5H17V7.5H20V16.5H29V19.5H20V28.5H17V19.5Z" fill="#3880E8" />
    //   </g>
    // </svg>
  );
}
